import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { AuthProvider } from './auth/AuthContext';
import { Root } from './auth/Root';
import './ui/styles.css';

const container = document.getElementById('root');
if (!container) throw new Error('#root element is missing from index.html');

// The desktop shell is an offline tool; the web deployment is the paid,
// account-gated surface. Tauri injects this global into its webview, so the
// same bundle can serve both without forcing desktop users through a server.
const desktopShell =
  typeof window !== 'undefined' && ('__TAURI_INTERNALS__' in window || '__TAURI__' in window);

createRoot(container).render(
  <StrictMode>
    {desktopShell ? (
      <App />
    ) : (
      <AuthProvider>
        <Root />
      </AuthProvider>
    )}
  </StrictMode>,
);
